import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { quickQuoteEndpoints } from "../../api/quickQuote";

export const fetchQuickQuotes = createAsyncThunk(
  "quickQuote/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await quickQuoteEndpoints.getAll();
      return response.data || []; // Ensure we always return an array
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch quotes"
      );
    }
  }
);

export const deleteQuickQuote = createAsyncThunk(
  "quickQuote/delete",
  async (id, { rejectWithValue }) => {
    try {
      await quickQuoteEndpoints.delete(id);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete quote"
      );
    }
  }
);

export const getQuoteById = createAsyncThunk(
  "quickQuote/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await quickQuoteEndpoints.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch quote details"
      );
    }
  }
);

const quickQuoteSlice = createSlice({
  name: "quickQuote",
  initialState: {
    quotes: [], // Initialize as empty array instead of null
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuickQuotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuickQuotes.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.quotes = Array.isArray(payload) ? payload : [];
      })
      .addCase(fetchQuickQuotes.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.quotes = []; // Reset to empty array on error
      })
      .addCase(deleteQuickQuote.fulfilled, (state, { payload }) => {
        state.quotes = state.quotes.filter((quote) => quote.id !== payload);
      })
      .addCase(getQuoteById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuoteById.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.currentQuote = payload;
      })
      .addCase(getQuoteById.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export default quickQuoteSlice.reducer;
